import BillingSummaryReportEditConfigController from './BillingSummaryReportEditConfigController'

export default class BillingSummaryReportEditResultConfigController extends BillingSummaryReportEditConfigController {}

BillingSummaryReportEditResultConfigController.prototype.makeReportParamsAccordingToFeatures = function(reportParameters) {
    return reportParameters
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/BillingSummaryReportEditResultConfigController.js